export default {
  not_localised: 'This document is not yet available in your region. Showing the English version.',
};
